import { jsx as _jsx } from "react/jsx-runtime";
import { QueryClientProvider, QueryClient, Hydrate } from '@tanstack/react-query';
import { DefaultProviders, isServer } from '@phishtool/ui';
import { queryClient } from '~service';
import theme from '~styles/theme';
const Providers = ({ children, staticData, query }) => {
    const queryClientToUse = isServer ? new QueryClient() : queryClient;
    return (_jsx(QueryClientProvider, { client: queryClientToUse, children: _jsx(Hydrate, { state: query, children: _jsx(DefaultProviders, { theme: theme, staticData: staticData, children: children }) }) }));
};
export default Providers;
